import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUploadImageMutation } from '../api/profileApi';

interface ProfileFormProps {
  editMode: boolean;
  file: File | null;
  setFile: any;
  initialProfile: {
    id?: number
    name: string;
    jobTitle: string;
    techStack: string[];
    linkedin: string;
    github: string;
    email: string;
    profilePic?: string;
    tags?: string[];
  }[];
  
  onUpdate: (data: any) => void; // Callback function to handle update
  onCancel: () => void; // Callback function to handle cancel
}

const ProfileForm: React.FC<ProfileFormProps> = ({
  initialProfile,
  onUpdate,
  onCancel,
  file,
  setFile,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(initialProfile[0]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState<string[]>([]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handlePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    console.log('selected file', selectedFile)
    if (selectedFile) {
      setFile(selectedFile); // Set file for uploading
      setFormData((prev) => ({ ...prev, profilePic: selectedFile.name }));
    }
  };
  console.log('file?????',file)
  console.log('tags?????',tags)

  console.log('formData', formData)
  const [uploadImage] = useUploadImageMutation();

  const handleTechStackChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      techStack: value.split(',').map((item) => item.trim()), // Convert to array
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      let profilePicFilename = formData.profilePic;
      let profilePicTags = formData.tags;

    // Upload profile picture if a new file was selected
    if (file) {
      const formData = new FormData();
      formData.append('file', file as any);
      console.log('imageFormData', formData, file)
      const response = await uploadImage(formData).unwrap();
      profilePicFilename = response.filename;
      profilePicTags = response.tags
      setTags(response.tags)
      console.log('response?????', response, response.tags)

    }

    const profileData = {
      ...formData,
      profilePic: profilePicFilename,
      tags: profilePicTags
    };
      console.log('profileData???', profileData)
      await onUpdate(profileData) // Call the update function with form data
    } catch (error) {
      console.error('Error updating profile:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{
        mt: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
      >
        <Box component="form" sx={{ mt: 1, width: '100%' }}>
          <TextField
            name="name"
            label={t('Name')}
            variant="outlined"
            value={formData.name}
            onChange={handleChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          <TextField
            name="jobTitle"
            label={t('Job Title')}
            variant="outlined"
            value={formData.jobTitle}
            onChange={handleChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          <TextField
            name="techStack"
            label={t('Tech Stack (comma separated)')}
            variant="outlined"
            value={formData.techStack.join(', ')} // Join array for display
            onChange={handleTechStackChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          <TextField
            name="linkedin"
            label={t('LinkedIn URL')}
            variant="outlined"
            value={formData.linkedin}
            onChange={handleChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          <TextField
            name="github"
            label={t('GitHub URL')}
            variant="outlined"
            value={formData.github}
            onChange={handleChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          <TextField
            name="email"
            label={t('Email')}
            variant="outlined"
            value={formData.email}
            onChange={handleChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            required
            fullWidth
            size='small'
            sx={{ mb: 2 }}
          />
          {/* Profile Picture Upload */}
        <Box>
        {/* Upload Profile Picture */}
        <input
          type="file"
          accept="image/*"
          id="profilePicInput"
          style={{ display: 'none' }}
          onChange={(e) => handlePicChange(e)}
        />
        <label htmlFor="profilePicInput">
          <Button variant="contained" component="span">
            Upload Profile Picture
          </Button>
        </label>
        <Button onClick={handleSubmit} disabled={!file || loading}>
          {loading ? <CircularProgress size={20} /> : 'Save Image'}
        </Button>

        {formData.profilePic && (
          <Box>
            <Typography variant="subtitle1">Optimized Image Preview:</Typography>
            <img
              src={`http://localhost:8000/files/image/${formData.profilePic}`}
              alt="Profile Preview"
              style={{ width: '100px', height: '100px', borderRadius: '50%' }}
            />
          </Box>
        )}

        {/* Display Image Tags */}
        {/* {formData?.tags && formData.tags?.length > 0 && (
          <Box mt={2}>
            <Typography variant="subtitle2">Detected Tags:</Typography>
            <Box>
              {formData.tags.map((tag) => (
                <Typography variant="body2" key={tag}>
                  {tag}
                </Typography>
              ))}
            </Box>
          </Box>
        )} */}
        </Box>
          <Box mb={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel} color="secondary" sx={{ borderRadius: 20}}>
              {t('Cancel')}
            </Button>
            <Button onClick={handleSubmit} color="primary" type="submit" disabled={loading} sx={{ borderRadius: 20}}>
              {loading ? <CircularProgress size={24} /> : t('Update')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ProfileForm;
